import { Link } from "react-router-dom";
import { Hourglass, ArrowLeft } from "lucide-react";
import { NAV, EXTRA_PHASE2, PHASE2_INFO } from "./nav";

export default function Phase2Page({ module }) {
  const meta = NAV.find((n) => n.key === module) || EXTRA_PHASE2[module];
  const Icon = meta?.icon || Hourglass;
  return (
    <div className="max-w-xl mx-auto text-center py-16" data-testid={`phase2-page-${module}`}>
      <div className="h-16 w-16 mx-auto rounded-2xl bg-[#0B1530] text-[#E8A33D] flex items-center justify-center mb-6">
        <Icon className="h-7 w-7" />
      </div>
      <p className="text-[11px] uppercase tracking-[0.2em] text-[#B87A1F] font-semibold mb-2">Coming in Phase 2</p>
      <h1 className="font-heading text-3xl font-semibold text-[#0B1530] mb-3">{meta?.label}</h1>
      <p className="text-slate-600 text-sm leading-relaxed mb-2">{PHASE2_INFO[module]}</p>
      <p className="text-slate-500 text-sm mb-8">This module isn't available yet. Nothing here is live, and no data is collected.</p>
      <Link to="/crm-app" className="inline-flex items-center gap-2 text-sm font-medium text-[#0B1530] hover:underline" data-testid="phase2-back-home">
        <ArrowLeft className="h-4 w-4" /> Back to Home
      </Link>
    </div>
  );
}
